import React, { useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Bgimage from "../HomePage/Bgimagesection/Bgimage";
import Footer from "../../components/Footer/Footer";
import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import { experimentalStyled as styled } from "@mui/material/styles";
import { Helmet } from "react-helmet-async";
import VideoWebAppDevelopment from "../../../src/Assets/Video/WebDevelopment.mp4";

import servicelogo1 from "../../../src/Assets/Images/Servicesinnerpageicons/image 49.webp";
import servicelogo2 from "../../../src/Assets/Images/Servicesinnerpageicons/image 50.webp";
import servicelogo3 from "../../../src/Assets/Images/Servicesinnerpageicons/image 51.webp";
import servicelogo4 from "../../../src/Assets/Images/Servicesinnerpageicons/image 52.webp";
import servicelogo5 from "../../../src/Assets/Images/Servicesinnerpageicons/image 53.webp";
import FloatingContactButton from "../../components/ContactUs/FloatingContactButton";
import FloatingWhatsappButton from "../../components/ContactUs/FloatingWhatsappButton";

const content = [
  "Understanding the Business",
  "UI/UX representation and Prototyping",
  "Developing the product",
  "Quality Assurance and Deployment",
  "Website Maintenance",
];

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  color: theme.palette.text.secondary,
}));

function Webdevinner() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the window to the top when the component mounts
  }, []);

  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
        <title>MERN Stack Web Development Services | Custom Web Apps - Dwebbox</title>
        <meta
          name="description"
          content="Transform your business with high-performance MERN stack web development. Dwebbox specializes in custom React.js, Node.js, and MongoDB solutions for scalable web applications."
        />
        <meta
          name="keywords"
          content="MERN stack development, React.js development, Node.js backend, custom web applications, full stack development agency, MongoDB solutions"
        />
        <link rel="canonical" href="https://dwebbox.com/webdevelopment" />

        {/* Service Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Web Development",
            "provider": {
              "@type": "Organization",
              "name": "Dwebbox"
            },
            "description": "Custom web development services specializing in MERN stack, React, and high-performance business applications.",
            "areaServed": "Worldwide",
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Web Development Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "MERN Stack Development"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "UI/UX Design"
                  }
                }
              ]
            }
          })}
        </script>
      </Helmet>
      <FloatingContactButton />
      <FloatingWhatsappButton />
      <Navbar />
      <div>
        <Box sx={{ width: "100%", background: "#181818" }}>
          <Container
            component="main"
            sx={{ pt: 8, pb: 8, background: "#181818" }}
          >
            <Typography
              paragraph
              sx={{
                color: "#ffffff",
                fontSize: "20px",
                fontFamily: "DM Sans_18pt-ExtraLight",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "18px",
                },
              }}
            >
              <span
                style={{
                  content: "''",
                  display: "inline-block",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  background: "white",
                  marginRight: "5px",
                }}
              ></span>{" "}
              Our Services {/* Add a span with the bullet class */}
            </Typography>
            <Typography
              variant="h1"
              sx={{
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                fontSize: "70px",
                fontFamily: "Epilogue",
                fontWeight: "600",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "24px",
                },
              }}
            >
              Web Development
            </Typography>
            <Typography
              variant="h2"
              sx={{
                color: "#ffffff",
                marginTop: "10vh",
                display: "flex",
                alignItems: "center",
                fontSize: "48px",
                fontFamily: "Epilogue",
                fontWeight: "600",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "24px",
                },
              }}
            >
              Where Pixels Meet Quirks and Code Dances in Digital Harmony!
            </Typography>
            <Typography
              paragraph
              sx={{
                color: "#ffffff",
                fontSize: "24px",
                marginTop: "5vh",
                fontWeight: "250",
                fontFamily: "DM Sans_18pt-ExtraLight",
                width: "95%",
              }}
            >
              We have deep expertise in a wide variety of technologies used for
              web development. From frontend frameworks like Angular and React
              to Node in the backend, we have experience in creating websites
              with the latest tools and technologies. If you prefer a specific
              technology, let us know, and we will incorporate it.
            </Typography>
            <Typography
              variant="h3"
              sx={{
                color: "#ffffff",
                marginTop: "10vh",
                display: "flex",
                alignItems: "center",
                fontSize: "32px",
                fontFamily: "Epilogue",
                fontWeight: "600",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "24px",
                },
              }}
            >
              Here is the five-step process we follow to create the ideal
              website for you to engage with your customers online:
            </Typography>
          </Container>

          <Container
            component="main"
            sx={{
              pt: 3,
              pb: 5,
              background: "#181818",
              display: "flex",
              justifyContent: "space-between",
              height: "80vh",
              "@media (max-width:600px)": {
                // Styles for screens with a maximum width of 600px (mobile view)
                flexDirection: "column",
                height: "130vh",
              },
            }}
          >
            <Box
              sx={{
                background: "#ffffff",
                width: "40%",
                height: "90%",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  width: "90%",
                  marginBottom: "5vh",
                  height: "40%",
                },
              }}
            >
              <video
                src={VideoWebAppDevelopment}
                autoPlay
                loop
                muted
                playsInline
                style={{ width: "100%", height: "100%", background: "black" }}
                alt=""
              />
            </Box>

            <Box
              sx={{
                width: "55%",
                height: "90%",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  width: "90%",
                },
              }}
            >
              <Box sx={{ flexGrow: 1 }}>
                <Grid
                  container
                  spacing={{ xs: 2, md: 0 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                  className="inner-page-itemgrid"
                >
                  {[
                    servicelogo1,
                    servicelogo2,
                    servicelogo3,
                    servicelogo4,
                    servicelogo5,
                  ].map((serviceLogo, index) => (
                    <Grid item xs={2} sm={4} md={4} key={index}>
                      <Item
                        sx={{
                          borderRadius: "0",
                          border: "1px solid rgba(255, 255, 255, 0.2)",
                          background: "#181818",
                          height: "30vh",
                          "@media (max-width:600px)": {
                            // Styles for screens with a maximum width of 600px (mobile view)
                            height: "22vh",
                            width: "111%",
                            textAlign: "center",
                          },
                        }}
                      >
                        <img
                          src={serviceLogo}
                          alt={`Service Logo ${index + 1}`}
                          style={{ maxWidth: "67px", maxHeight: "67px" }}
                        />
                        <Typography
                          variant="body1"
                          sx={{
                            color: "#ffffff",
                            fontSize: "16px",
                            fontWeight: "600",
                            fontFamily: "Epilogue",
                            "@media (max-width:600px)": {
                              // Styles for screens with a maximum width of 600px (mobile view)
                              fontSize: "12px",
                              fontWeight: "500",
                              marginTop: "1vh",
                              textAlign: "center",
                            },
                          }}
                        >
                          {content[index]}
                        </Typography>
                      </Item>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          </Container>
        </Box>
      </div>
      <Bgimage />
      <Footer />
    </div>
  );
}

export default Webdevinner;
